// extracted by css-extract-rspack-plugin
export default {"SanitizedHtml":"text-cell-module__SanitizedHtml__w_BT2","wrapping":"text-cell-module__wrapping__xpXBy"};